import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import cartIcon from "src/assets/images/cart-white-icon.png";
import greenIcon from "src/assets/images/cart-icon-green.png";
import { RootState, AppDispatch } from "src/Store/store";
import { addItem } from "src/Store/cartSlice";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import OutOfStackTag from "src/Components/GlobalComponents/Widget/OutOfStackTag";
import httpRequest from "src/helpers/httpRequest";
import { setCartItems } from "src/Store/Cart";
import { toast } from "react-toastify";
import { CartItemToast } from "src/lib/constans";

interface IProps {
  textBtn?: boolean;
  productId: string;
  type: "diagnostic" | "pharmacy" | "homecare";
  prescriptionRequired: boolean;
  quantity: number;
  stockQuantity?: number;
  itemType?: "product" | "package";
  greenCartIcon?: boolean;
  btnFull?: boolean;
  btnStyle?: React.CSSProperties;
  id?: string;
  count?: number;
}

const AddCartComponent: React.FC<IProps> = ({
  textBtn = false,
  productId = "",
  type = "diagnostic",
  prescriptionRequired = false,
  quantity = 1,
  itemType = "product",
  greenCartIcon = false,
  stockQuantity = 1,
  btnFull = false,
  btnStyle = {},
  id = "",
  count = 1,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { pharmacyProducts = [], diagnosticProducts = [] } = useSelector(
    (store: RootState) => store.cartSlice
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { cartItems } = useSelector((store: RootState) => store.cart);
  const { isLogged } = useSelector((store: RootState) => store.appReducer);
  const [isAdded, setIsAdded] = useState<boolean>(false);
  const [prescriptionRequiredModal, setPrescriptionRequiredModal] =
    useState<boolean>(false);
  const checkPrescribed = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (stockQuantity === 0) return;

    // if (prescriptionRequired) {
    //   setPrescriptionRequiredModal(true);
    // } else {
    addToCart(e);
    // }
  };
  const addToCart = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (isLoading) return;
    if (isLogged) {
      setIsLoading(true);
      const { err, res } = await httpRequest({
        path: "/cart/add",
        method: "post",
        params: {
          items: [
            {
              quantity: count,
              productId: productId,
              type: type === "pharmacy" ? "pharmacy" : itemType,
            },
          ],
        },
      });
      if (err) {
        toast.error(CartItemToast["error"][`${type}-${itemType}` as keyof typeof CartItemToast["error"]]);
        return;
      } else {
        toast.success(CartItemToast["success"][`${type}-${itemType}` as keyof typeof CartItemToast["success"]]);
        const items = res.cartItems || [];
        dispatch(setCartItems([...items]));
      }
    } else {
      if (type === "diagnostic") {
        dispatch(
          addItem({
            category: "diagnosticProducts",
            product: { _id: productId, quantity: count, itemType },
          })
        );
      } else {
        dispatch(
          addItem({
            category: "pharmacyProducts",
            product: { _id: productId, quantity: count },
          })
        );
      }
    }
    setPrescriptionRequiredModal(false);
    setIsLoading(false);
  };

  useEffect(() => {
    if (isLogged) {
      setIsAdded(cartItems?.some((v: any) => v.productId === productId));
    } else {
      if (type === "pharmacy") {
        setIsAdded(pharmacyProducts?.some((v) => v._id === productId));
      } else if (type === "diagnostic") {
        setIsAdded(diagnosticProducts?.some((v) => v._id === productId));
      }
    }
  }, [
    cartItems,
    productId,
    type,
    pharmacyProducts,
    diagnosticProducts,
    // isLogged,
  ]);

  if (quantity <= 0 || stockQuantity <= 0) return <OutOfStackTag />;

  return (
    <>
      <Tooltip title={isAdded ? "Already in Cart" : "Add to Cart"}>
        {greenCartIcon ? (
          <button
            id={id}
            disabled={isAdded || stockQuantity === 0}
            onClick={checkPrescribed}
            className={`${
              isAdded || stockQuantity === 0 ? "cursor-not-allowed" : ""
            }`}
          >
            <img src={greenIcon} alt="Cart" className="w-[20px]" />
          </button>
        ) : textBtn ? (
          <button
            id={id}
            disabled={isAdded || stockQuantity === 0}
            className={`theme-gradient-green-bottom add-to-cart-text-btn text-[#FFFFFF] ${
              btnFull ? "w-full" : ""
            } font-size-14px font-Poppins-Medium flex items-center justify-center gap-2 ${
              isAdded || stockQuantity === 0 ? "cursor-not-allowed" : ""
            }`}
            onClick={checkPrescribed}
            style={{ ...btnStyle }}
          >
            {isAdded ? "Added To Cart" : "Add To Cart"}
          </button>
        ) : (
          <button
            id={id}
            disabled={isAdded || stockQuantity === 0}
            className={`add-to-cart-products ${
              isAdded || stockQuantity === 0 ? "cursor-not-allowed" : ""
            }`}
            onClick={checkPrescribed}
          >
            <img src={cartIcon} alt="Cart Icon" />
          </button>
        )}
      </Tooltip>
    </>
  );
};

export default AddCartComponent;
